export function createHitSlop(ht: number, hv?: number) {
  if (hv) {
    return {
      top: ht,
      left: hv,
      right: hv,
      bottom: ht,
    }
  }

  return {
    top: ht,
    left: ht,
    right: ht,
    bottom: ht,
  }
}
